const EVENT = {
  CART: {
    UPDATE: 'cart:update',
  },
  ACCORDION: {
    DRAWERCLOSED: 'accordion-drawer:closed',
  },
  WISHLIST: {
    CONTENTS_LOADED: 'wishlist:contents-loaded',
  },
  UNDERLAY: {
    CLICKED: 'underlay:clicked',
  },
  FILTERS: {
    FILTER_LIST_OPENED: 'filters:opened',
    FILTER_LIST_CLOSED: 'filters:closed',
  },
  HEADER: {
    HIDDEN: 'header:hidden',
    VISIBLE: 'header:visible',
  },
};

export default EVENT;
